import React from 'react'
import cx from 'classnames'
import Container from './Container'

type FullBleedContainerProps = {
  children: React.ReactNode
  className?: string
}

function FullBleedContainer(props: FullBleedContainerProps) {
  const { children, className } = props
  return (
    <div className={cx('full-bleed-container', className)}>
      <Container>{children}</Container>
      <style jsx>{`
        .full-bleed-container {
          grid-column: 1 / 4;
        }
      `}</style>
    </div>
  )
}

export default FullBleedContainer
